import { render, staticRenderFns } from "./SubscriptionDeliveryPickUp.vue?vue&type=template&id=70532163&"
import script from "./SubscriptionDeliveryPickUp.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDeliveryPickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports